module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"text":"W obecnej chwili poszukujemy projektów fotowoltaicznych, które będą gotowe do udziału w aukcji zaplanowanej na 3 grudnia 2020 roku."}}')
  delete Component.options._Ctor
}
